module.exports = __webpack_public_path__ + "img/eos.d431754f.svg";